import { PopoverVariantType } from './../popover/variants';
export const commonStyles = (FOUNDATIONS, FONT, SHADOWS) => ({
    popoverVariant: PopoverVariantType.MODAL,
    container: {
        background_color: FOUNDATIONS.color_comp_containers_bg,
        overflow_y: 'auto',
        display: 'flex',
        align_items: 'center',
        flex_flow: 'column nowrap',
        box_sizing: 'border-box',
    },
    actionsAndHeaderContainer: {
        display: 'flex',
        width: '100%',
        box_shadow: SHADOWS.shadow_40,
    },
    content: {
        margin_top: FOUNDATIONS.spacing_00,
        width: '100%',
        flex: 'auto',
        overflow_y: 'auto',
    },
    headerContainer: {
        flex: 1,
    },
    actionsContainer: {
        // to maintain actions to the right when there is no header
        margin_left: 'auto',
        padding: `0 0 0 ${FOUNDATIONS.spacing_150}`,
    },
    titleContainer: {
        width: '100%',
    },
    dragIconContainer: {
        display: 'flex',
        align_items: 'center',
        justify_content: 'center',
    },
    draggableIconContainer: {
        padding: `${FOUNDATIONS.spacing_150} 0 0 0`,
    },
});
//# sourceMappingURL=commonStyles.js.map